import _ from 'lodash';
import Vue from 'vue';
import VueCookie from 'vue-cookie';
import * as qs from '@/services/querystring/querystring.constants';

Vue.use(VueCookie);

export default {
    /**
     * Takes an object, usually from $route.params, compare with valid_querystring constant
     * and return the proper object
     * @param {Object} params - qs / params object
     * @return {Object}
     */

    checkParams(params) {
        const validFields = {};
        const keyOverrides = {
            eid: 'engagement_id',
            segid: 'segment_anonymous_id',
        };

        _.forEach(params, (val, key) => {
            if (_.includes(qs.VALID_QUERYSTRINGS, key)) {
                const qsValue = _.isArray(val) ? _.head(_.compact(val)) : val;

                // only assign property to object if the value exists, this prevents null overwriting
                if (qsValue) {
                    const overrideKey = keyOverrides[key];
                    validFields[overrideKey || key] = qsValue;
                }
            }
        });
        return validFields;
    },

    /**
     * walks through the valid cookies we could get, check if they exists,
     * if so return all valid cookies we find
     * @return {Object}
     */
    checkCookies() {
        const validFields = {};
        _.forEach(qs.VALID_COOKIES, (cookieName) => {
            const cookie = VueCookie.get(`www_${cookieName}`);
            const cookieValue = _.isArray(cookie) ? _.head(_.compact(cookie)) : cookie;

            // only assign property to object if the value exists, this prevents null overwriting
            if (cookieValue) {
                validFields[cookieName] = cookieValue;
            }
        });
        return validFields;
    },

    /**
     * checks if form name exists
     * @return {Boolean}
     */
    checkFormName(formName) {
        return _.includes(qs.VALID_FORM_NAMES, formName);
    },
};
